module.exports = __webpack_public_path__ + "images/0797d0a4b1047dabe3490c0f145d022e20d510f47128ac2e7f87d831aef3a1e9.svg";